
import { ChildrenModelBase } from "./children-base.model";
import { QueryableColumn } from "./queryable-column.model";

export class QueryableTable extends ChildrenModelBase {
  public name: string;
  public queryableColumns: QueryableColumn[];
}
